module.exports = __webpack_public_path__ + "img/background-5-mb.f81b8645.jpg";